import styled from '@emotion/styled';

import { Button } from 'components/buttons';
import IconCheckCircle from 'components/icons/checkCircle';
import IconCheckCircleOutline from 'components/icons/checkCircleOutline';
import IconChevron from 'components/icons/chevron';
import IconCross from 'components/icons/cross';

export const ExpandSectionHandle = styled(Button)((_) => ({
  width: '100%',
  padding: '10px 10px',
  span: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

export const ExpandHandleEnd = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  fontSize: 12,
  fontWeight: 400,
}));

export const ExpandSectionIcon = styled(IconChevron)<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  height: 20,
  width: 20,
  transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: 'transform 0.2s ease-in-out',
  marginLeft: 'auto',
  path: {
    fill: theme.colors.primary,
  },
}));

export const Header = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
}));

export const Item = styled.div((_) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 20,
  width: '100%',
  fontSize: 13,
}));

export const InactiveCheckIcon = styled(IconCheckCircleOutline)((props) => ({
  path: {
    fill: props.theme.colors.container.tertiary,
  },
}));

export const RowGap = styled.div<{ gap: number }>(({ gap }) => ({
  alignItems: 'center',
  display: 'flex',
  gap,
}));

export const CheckIcon = styled(IconCheckCircle)((props) => ({
  color: props.theme.colors.text.accent,
  margin: '3px 3px 4px 0px',
  overflow: 'visible',
}));

export const Row = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

export const CollapseContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  padding: '5px 10px',
}));

export const FailedIcon = styled(IconCross)((props) => ({
  path: {
    fill: props.theme.colors.error.main,
  },
}));
